import { useTooltipStore } from '@/stores/tooltip.store';
import type {
  TooltipConfig,
  TooltipPlacement,
  TooltipPosition,
} from '@/stores/tooltip.store';

export type { TooltipConfig, TooltipPlacement, TooltipPosition };

/**
 * Tooltip hook exposing reactive tooltip state plus actions,
 * mirroring the Angular TooltipService surface.
 */
export function useTooltip() {
  const visible = useTooltipStore((s) => s.visible);
  const content = useTooltipStore((s) => s.content);
  const maxWidth = useTooltipStore((s) => s.maxWidth);
  const placement = useTooltipStore((s) => s.placement);

  const showTooltip = useTooltipStore((s) => s.showTooltip);
  const hideTooltip = useTooltipStore((s) => s.hideTooltip);
  const hideTooltipImmediate = useTooltipStore((s) => s.hideTooltipImmediate);
  const updatePosition = useTooltipStore((s) => s.updatePosition);
  const init = useTooltipStore((s) => s.init);
  const destroy = useTooltipStore((s) => s.destroy);

  return {
    visible,
    content,
    maxWidth,
    placement,
    showTooltip,
    hideTooltip,
    hideTooltipImmediate,
    updatePosition,
    init,
    destroy,
  };
}
